
import { ChannelGroup } from 'src/app/cms/ltv/ltv-content-group/data';
import { ChannelPackage } from './channel-package.model';
import { Genre } from './genre.model';
import { LiveStation } from './live-station-model';
import { Source } from './source.model';

export class Channel {
  constructor(
    public id?: number, //   id (integer, optional),
    public name?: string, //   name (string, optional),
    public mpId?: string,
    public guid?: string, //   guid (string, optional),
    public description?: string, //   description (string, optional),
    public logo?: string,
    public logoSec?: string,
    public liveId?: number,
    public no?: number, //   no (integer, optional),
    public urlName?: string, //   urlName (string, optional)
    public status?: string, //   status (string, optional),
    public quality?: string, //   quality (string, optional),
    public input?: string,
    public scale?: string, //   scale (string, optional),
    public language?: string,
    public recordStartTime?: number,
    public genre?: string,
    public isEncrypted?: boolean,
    public provider?: string, //   provider (string, optional)
    public pureStreamKey?: string, //   pureStreamKey (string, optional),
    public streamKey?: string, //   streamKey (string, optional),
    public profile?: string, //   profile (string, optional),
    public preset?: string, //   preset (string, optional),
    public token?: string, //   token (string, optional),
    public recordCount?: number, //   recordCount (integer, optional),
    public timeshiftEnabled?: boolean, //   timeshiftEnabled (boolean, optional),
    public recordInterval?: number, //   recordInterval (integer, optional),
    public recordStarted?: boolean, //   recordStarted (boolean, optional),
    public backwardTimeShiftDuration?: number,
    public restartTv?: boolean, //   restartTv (boolean, optional),
    public epgSourceUrl?: string,
    public epgChannelId?: number, //   epgChannelId (integer, optional),
    public stationId?: number,
    public source?: Source,
    public channelPackage?: ChannelPackage,
    public recordingType?: string, //   recordingType (string, optional) = ['Epg', 'Time'],
    public channelType?: string, // ['Multicast', 'Unicast', 'External'],,
    public channelGroups?: ChannelGroup[],
    public deviceTypes?: string[],
    public liveStations?: LiveStation[],
    public ppvEnable?: boolean,
    public genres?: Genre[],
    public mwChannelId?: string,
    public preBuffer?: number,
    public postBuffer?: number,
    public mwPhysicalChannelCode?: string,
    public updatePastPrograms?: boolean,
    public priority?: number,
    public isStatusActive?: boolean,
    public detectionStartTime?: number,
    public detectionEndTime?: number,
    public autoCheck?: boolean,
    public smartSign?: boolean,
    public keywords?: string,
    public notInChildProfile?: boolean,
    public isAdult?: boolean,
    public isRadio?: boolean,
    public dvbcOnly?: boolean,
    public ottOnly?: boolean,
    public tvRemoteNumber?: number,
    public concurrentWatchCount?: number,
    public dvrEnabled?: boolean,
    public dvrDuration?: number,
    public npvrEnabled?: boolean,
    public catchupLicenseDuration?: number,
    public sid?: number,
    public displayNumber?: number,
    public newChannelNotification?: boolean,
    public newChannelNotificationStartDate?: number,
    public newChannelNotificationEndDate?: number,
    public audios?: any[],
    public subtitles?: any[],
    public url?: string,
    public channelPackages?: any[],
    public drm?: boolean,
    public drmL1?: boolean,
    public keyEncryption?: boolean,
    public timeshift?: number,
    public audioContentLanguageNames?: string,
    public audioContentLanguageLabels?: string,
    public textContentLanguageNames?: string,
    public textContentLanguageLabels?: string,
  ) { }
}

// Channel {
//   backwardTimeShiftDuration (integer, optional),
//   channelType (string, optional) = ['Multicast', 'Unicast', 'External'],
//   description (string, optional),
//   epgChannelId (integer, optional),
//   epgSourceUrl (string, optional),
//   genre (string, optional),
//   genres (Array[Genre], optional),
//   guid (string, optional),
//   id (integer, optional),
//   input (string, optional),
//   isEncrypted (boolean, optional),
//   language (string, optional),
//   logo (string, optional),
//   mwChannelId (string, optional),
//   mwPhysicalChannelCode (string, optional),
//   name (string, optional),
//   no (integer, optional),
//   npvrEnabled (boolean, optional),
//   platforms (Array[string], optional),
//   postBuffer (integer, optional),
//   ppvEnable (boolean, optional),
//   preBuffer (integer, optional),
//   preset (string, optional),
//   profile (string, optional),
//   programGroup (ProgramGroup, optional),
//   provider (string, optional),
//   pureStreamKey (string, optional),
//   quality (string, optional),
//   recordCount (integer, optional),
//   recordInterval (integer, optional),
//   recordStarted (boolean, optional),
//   recordingType (string, optional) = ['Epg', 'Time'],
//   restartTv (boolean, optional),
//   rtmpUrl (string, optional),
//   scale (string, optional),
//   status (string, optional),
//   streamKey (string, optional),
//   timeshiftEnabled (boolean, optional),
//   token (string, optional),
//   tstvEnable (boolean, optional),
//   type (string, optional),
//   url (string, optional),
//   urlName (string, optional)
//   }
